/**
 * Swatches for an unset color. The block does not paint these; an unset attribute follows the theme.
 * Mirrored by Tiptap::Components::Shared::TipJarMethods.
 */
export const TIP_JAR_DEFAULT_COLORS = {
  backgroundColor: '#FFFFFF',
  textColor: '#030712',
  progressColor: '#030712',
  onProgressColor: '#FFFFFF',
} as const;

export type TipJarColorAttribute = keyof typeof TIP_JAR_DEFAULT_COLORS;

/** Where each color sits in the jar's defaults, `TipJar#block_colors` in Swarm. */
export const TIP_JAR_BLOCK_COLOR_KEYS = {
  backgroundColor: 'background_color',
  textColor: 'text_color',
  progressColor: 'progress_color',
  onProgressColor: 'on_progress_color',
} as const satisfies Record<TipJarColorAttribute, string>;

/** Dark card saved before the block followed the theme. Holding exactly these means the writer never restyled it. */
export const TIP_JAR_LEGACY_DEFAULT_COLORS = {
  backgroundColor: '#12201A',
  textColor: '#FFFFFF',
  progressColor: '#3FD18A',
} as const satisfies Partial<Record<TipJarColorAttribute, string>>;
